<visitor-mobile-navbar [OpenLeftInput]="open1"></visitor-mobile-navbar>
<visitor-mobile-header></visitor-mobile-header>
<visitor-mobile-services (open)="openContact($event)"></visitor-mobile-services>
<visitor-mobile-projects></visitor-mobile-projects>
<visitor-mobile-clients></visitor-mobile-clients>
<visitor-mobile-contact></visitor-mobile-contact>
<visitor-shared-footer></visitor-shared-footer>
